import { Injectable } from '@angular/core';
import { McticHttpClient, McticHttpParams, Page, Pageable } from '@mctic/ng-core';
import { ConsultaPropriedadeIntelectualVO, ProjetoPropriedadeIntelectual, PropriedadeIntelectual } from '../shared/model';

@Injectable({
  providedIn: 'root'
})
export class PropriedadeIntelectualService {

  private readonly service = '/sepin-backend/rest/propriedades-intelectuais';

  constructor(private readonly http: McticHttpClient) {
  }

  consultar(consultaPropriedadeIntelectualVo: ConsultaPropriedadeIntelectualVO) {
    return this.http.get<ProjetoPropriedadeIntelectual[]>(
      `${this.service}/elegiveis/${consultaPropriedadeIntelectualVo.projeto}`
    );
  }

  atualizar(propriedadesIntelectuis: ProjetoPropriedadeIntelectual[]) {
    return this.http.post(`${this.service}/`, propriedadesIntelectuis);
  }

  isVinculoComProjeto(idPropriedadeIntelectual){
    return this.http.get(`${this.service}/possui-outros-vinculos/${idPropriedadeIntelectual}`);
  }
}
